import { fanBundleRefFor, fanMaxPxForZoom } from "./fan-code.js";
import { createFannedPathLayer } from "./fanned-path-layer.js";
import { buildRouteShapePaths, isRouteShapePath, largestBundleIn, } from "./route-shape-paths.js";
export const routeShapeLayerState = (data, zoom, options = {}) => {
    const cleaned = options.cleaned ??
        data.some((row) => isRouteShapePath(row) ? row.fanCodes != null : row.slots != null);
    const largest = options.largestBundle ?? (cleaned ? largestBundleIn(data) : 0);
    return {
        cleaned,
        fanZoom: cleaned ? zoom : 0,
        fanBundleRef: fanBundleRefFor(largest),
        fanMaxPx: options.fanMaxPx ?? fanMaxPxForZoom(zoom),
    };
};
export const routeShapeLayerProps = ({ data, zoom, cleaned, largestBundle, fanZoomBase, fanZoomSpread, fanGapSpread, fanMaxPx, trunkGain, ...layerProps }) => {
    const state = routeShapeLayerState(data, zoom, { cleaned, largestBundle, fanMaxPx });
    const paths = data.every(isRouteShapePath)
        ? data
        : buildRouteShapePaths(data, { cleaned: state.cleaned });
    return {
        ...layerProps,
        data: paths,
        getPath: (row) => row.path,
        getFanCodes: (row) => row.fanCodes,
        positionFormat: "XY",
        _pathType: "open",
        fanZoom: state.fanZoom,
        fanBundleRef: state.fanBundleRef,
        fanMaxPx: state.fanMaxPx,
        ...(fanZoomBase != null ? { fanZoomBase } : {}),
        ...(fanZoomSpread != null ? { fanZoomSpread } : {}),
        ...(fanGapSpread != null ? { fanGapSpread } : {}),
        ...(trunkGain != null ? { trunkGain } : {}),
    };
};
export function createRouteShapeLayer(deps) {
    const FannedPathLayer = createFannedPathLayer(deps);
    class RouteShapeLayer extends FannedPathLayer {
        static layerName = "RouteShapeLayer";
        constructor(props) {
            super(routeShapeLayerProps(props));
        }
    }
    return { FannedPathLayer, RouteShapeLayer };
}
//# sourceMappingURL=route-shape-layer.js.map